import dashbroad from '@/router/dashbroad'
import BillingManagement from '@/new-router/billing-management'
import FinancialManagement from '@/new-router/financial-management'
import OperationsManagement from '@/new-router/operations-management'
import StatisticsManagement from '@/new-router/statistics-management'
import PublicModules from '@/new-router/public-modules'
import UserCenter from '@/new-router/user-center'
import ProductCenter from '@/new-router/product-center'
import userSvg from '@/assets/font-svg/user.svg'
import userHoverSvg from '@/assets/font-svg/user_hover.svg'
import billingSvg from '@/assets/font-svg/billing.svg'
import billingHoverSvg from '@/assets/font-svg/billing_hover.svg'
import financialSvg from '@/assets/font-svg/financial.svg'
import financialHoverSvg from '@/assets/font-svg/financial_hover.svg'
import operationsSvg from '@/assets/font-svg/operations.svg'
import operationsHoverSvg from '@/assets/font-svg/operations_hover.svg'
import publicSvg from '@/assets/font-svg/public.svg'
import publicHoverSvg from '@/assets/font-svg/public_hover.svg'
import dataSvg from '@/assets/font-svg/data.svg'
import dataHoverSvg from '@/assets/font-svg/data_hover.svg'

const Home = () => import('@/views/Home/home')

export default [
  ...dashbroad,
  ProductCenter,
  {
    path: '/',
    name: 'user-center',
    title: '用户',
    component: Home,
    meta: {
      sort: 0,
      main: true,
      icon: userSvg,
      activeIcon: userHoverSvg,
      permission: 'user',
    },
    children: UserCenter,
  },
  {
    path: '/',
    name: 'billing-management',
    title: '账单',
    component: Home,
    meta: {
      sort: 0,
      modules: 'auth',
      icon: billingSvg,
      activeIcon: billingHoverSvg,
      permission: 'bill',
    },
    children: BillingManagement,
  },
  {
    path: '/',
    name: 'financial-management',
    title: '财务',
    component: Home,
    meta: {
      sort: 0,
      modules: 'auth',
      icon: financialSvg,
      activeIcon: financialHoverSvg,
      permission: 'finance:root',
    },
    children: FinancialManagement,
  },
  {
    path: '/',
    name: 'operations-management',
    title: '运营',
    component: Home,
    meta: {
      sort: 0,
      modules: 'auth',
      icon: operationsSvg,
      activeIcon: operationsHoverSvg,
      permission: 'operating',
    },
    children: OperationsManagement,
  },
  {
    path: '',
    name: 'public-modules',
    title: '公共',
    component: Home,
    meta: {
      sort: 0,
      modules: 'auth',
      icon: publicSvg,
      activeIcon: publicHoverSvg,
      permission: 'public',
    },
    children: PublicModules,
  },
  {
    path: '/',
    name: 'statistics-management',
    title: '数据',
    component: Home,
    meta: {
      sort: 0,
      modules: 'auth',
      icon: dataSvg,
      activeIcon: dataHoverSvg,
      permission: 'stat',
    },
    children: StatisticsManagement,
  },
]
